import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { ButtonBase } from "./ButtonBase";
import { colors } from "../../theme";
import { Icon } from "../Icon/Icon";
import { em } from "../../utils";
import { breakpoints } from "../Grid/breakpoints";

const Outer = styled(
  ({
    useContentWidth,
    primary,
    secondary,
    large,
    small,
    grey,
    rounded,
    ...props
  }) => <ButtonBase {...props} />
)`
  height: 54px;
  text-decoration: none;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 700;
  font-size: ${em(17)};
  font-family: 'GT-Walsheim', sans-serif;
  background-color: #D42022;
  color: white;
  padding: 0 30px;

  ${({ small }) =>
    small &&
    `
    height: 40px;
    font-size: ${em(11)};

  `}

  ${({ large }) =>
    large &&
    `
    @media (min-width: ${breakpoints.md}px) {
      height: 60px;
      font-size: ${em(20)};

    }
   `}

  ${({ primary }) =>
    primary &&
    `
    background-color: ${colors.primary};
    color: ${colors.white}
  `}

  ${({ secondary }) =>
    secondary &&
    `
    background-color: ${colors.secondary};
    color: ${colors.white}
  `}

  ${({ grey }) =>
    grey &&
    `
    background-color: #ddd;
    color: #666;
  `}

  ${({ disabled }) => disabled && "opacity: .3;"}

	${({ useContentWidth }) =>
    useContentWidth ? "display: inline-block; padding: 0 30px;" : "flex: 1;"}
`;

const Content = styled.span`
  height: 100%;
  display: flex;
  flex: 1;
  align-items: center;
`;

const Label = styled.span`
  line-height: 1;
  white-space: nowrap;
`;

const IconHolder = styled.div`
  ${props =>
    props.iconPosition === "left"
      ? `margin-right: ${props.large ? 18 : 14}px`
      : `margin-left: ${props.large ? 18 : 14}px`};
  position: relative;
  top: 1.5px;
`;

export const Button = ({
  to,
  href,
  onClick,
  primary,
  grey,
  label,
  icon,
  iconPosition = "left",
  iconSize = 16,
  children,
  useContentWidth,
  rounded,
  small,
  large,
  disabled,
  ...rest
}) => {
  const actions = disabled
    ? null
    : {
        to,
        href,
        onClick
      };

  return (
    <Outer
      {...actions}
      primary={primary}
      grey={grey}
      useContentWidth={useContentWidth}
      rounded={rounded}
      small={small}
      large={large}
      disabled={disabled}
      {...rest}
    >
      <Content primary={primary}>
        {icon &&
          iconPosition === "left" && (
            <IconHolder label={label} iconPosition={iconPosition} large={large}>
              <Icon name={icon} size={iconSize} />
            </IconHolder>
          )}

        {children ? children : <Label>{label}</Label>}

        {icon &&
          iconPosition === "right" && (
            <IconHolder label={label} iconPosition={iconPosition} large={large}>
              <Icon name={icon} size={iconSize} />
            </IconHolder>
          )}
      </Content>
    </Outer>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  to: PropTypes.string,
  children: PropTypes.any,
  href: PropTypes.string,
  primary: PropTypes.bool,
  grey: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  useContentWidth: PropTypes.bool,
  rounded: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Button/Button.js